// features/stream/streamSlice.js
import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
    name: "stream",
    initialState: {
        messages: [],
        connected: false,
        error: null,
        pauseCount: 0
    },
    reducers: {
        wsConnected(state) {
            state.connected = true;
        },
        wsDisconnected(state) {
            state.connected = false;
        },
        wsError(state, action) {
            console.error("WebSocket error in slice:", action.payload);
            state.error = action.payload;
        },
        wsMessage(state, action) {
            state.messages.push(action.payload);
        },
        clearMessages(state) {
            state.messages = [];
        },
        drainMessages(state, action) {
            // Remove exactly the first N messages (used after batch processing,
            // so messages that arrived mid-batch are kept for the next drain)
            state.messages.splice(0, action.payload);
        },
        wsPause(state) {
            state.pauseCount += 1;
        },
        wsResume(state) {
            state.pauseCount = Math.max(0, state.pauseCount - 1);
        },
    }
});

export const { wsConnected,
    wsDisconnected,
    wsError,
    wsMessage,
    clearMessages,
    drainMessages,
    wsPause,
    wsResume} =
    slice.actions;

export default slice.reducer;
